export const style = {
  container: {
    padding: "20px",
    backgroundColor: "#f4f7f6",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#000",
  },
  createGroupBtn: {
    backgroundColor: "#000",
    color: "#fff",
    borderRadius: "20px",
    textTransform: "none",
    padding: "8px 20px",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "20px",
    border: "1px solid #e0e0e0",
    boxShadow: "none",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "8px",
  },
  sectionSubtitle: {
    fontSize: "14px",
    color: "#757575",
    marginBottom: "20px",
  },
  inputLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
    marginBottom: "8px",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      backgroundColor: "#f9f9f9",
    },
  },
  checkboxGroup: {
    display: "flex",
    gap: "20px",
    marginTop: "20px",
  },
  checkboxLabel: {
    fontWeight: "500",
  },
  actionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
  },
  btnDraft: {
    backgroundColor: "#e0e0e0",
    color: "#000",
    textTransform: "none",
    padding: "10px 24px",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#d5d5d5",
    },
  },
  btnSend: {
    backgroundColor: "#000",
    color: "#fff",
    textTransform: "none",
    padding: "10px 24px",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  tableContainer: {
    boxShadow: "none",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
  },
  tableHead: {
    backgroundColor: "#f9f9f9",
    "& .MuiTableCell-root": {
      fontWeight: "600",
      fontSize: "14px",
    },
  },
  statusChip: {
    borderRadius: "16px",
    padding: "4px 12px",
    fontSize: "12px",
    fontWeight: "600",
    display: "inline-block",
  },
  statusDelivered: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
  },
  statusPending: {
    backgroundColor: "#fff8e1",
    color: "#f57f17",
  },
  statusFailed: {
    backgroundColor: "#ffebee",
    color: "#c62828",
  },
  linkAction: {
    textDecoration: "underline",
    color: "#333",
    cursor: "pointer",
    fontSize: "14px",
  },
  groupCard: {
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    padding: "20px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  groupHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  groupName: {
    fontWeight: "600",
    fontSize: "16px",
  },
  groupCount: {
    backgroundColor: "#f5f5f5",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    color: "#666",
  },
  groupDesc: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "20px",
  },
  createGroupCard: {
    border: "1px dashed #bdbdbd",
    borderRadius: "12px",
    padding: "20px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    textAlign: "center",
    backgroundColor: "#fcfcfc",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  modalBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '600px' },
    bgcolor: 'background.paper',
    borderRadius: '12px',
    boxShadow: 24,
    p: 4,
    maxHeight: '80vh',
    overflowY: 'auto',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 1,
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '600',
  },
  modalDesc: {
    fontSize: '14px',
    color: '#666',
    mb: 3,
  },
  selectedUsersBox: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginTop: "20px",
    padding: "16px",
  },
  selectedUsersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
};

export default style;
